import { Dimensions } from 'react-native';
export const WIDTH = Dimensions.get('window').width; // this is static size and changes only when we rotate device on mobile/tablet, for web and desktop we need to use react-native hook const {height, width} = useWindowDimensions();
export const HEIGHT = Dimensions.get('window').height;
//# sourceMappingURL=getSize.js.map